import { HelpData } from '../../components/Help/Manual/types';
import { HelpActionTypes } from '../actions/DataAction';
import { GET_AI_SETTINGS_SUCCESS, GET_PREFERENCES_SUCCESS, GET_USER_MANUAL_FAILURE, GET_USER_MANUAL_REQUEST, GET_USER_MANUAL_SUCCESS, SET_AI_SETTINGS, SET_AI_VOICES, SET_CHAT_LIST, SET_CITY, SET_COUNTRY, SET_CURRENCY, SET_JURISDICTION_COUNTRY, SET_MESSAGE_LIST, SET_PREFERENCES, SET_STATE, STORE_PUBSUB_CREDENTIALS } from '../types';

export interface AISettings {
  language: string;
  /** Legacy key — kept in sync with `CountryOfJurisdiction`, never written alone. */
  jurisdiction: string;
  /** Authoritative jurisdiction key — what the AI resolvers read. */
  CountryOfJurisdiction?: string;
  speaker_voice: string;
}
export interface IPreferences {
  UserID: string;
  UserType: string;
  CurrencyName: string;
  Currency: string;
  Communication: string;
  WhiteLableEnabled: boolean;
  ThemeColor: string
  DocumentSettingsEnabled: string;
}
export interface PubSubCredentials {
  endpoint: string;
  token: string;
  expires_in: number;
  hubs: string[];
}

interface Country {
  countries: [] | null;
  states: [] | null;
  cities: [] | null;
  CountryOfJurisdictionList: [] | null;
  currencies: [] | null;
  preferences: IPreferences | {};
  aiSettings: AISettings | null;
  chatList: any[] | [];
  userTypes: any[] | [];
  MessageList: any[] | [];
  aiVoices: any[] | [];
  pubsub: PubSubCredentials | null;
  loading: boolean;
  data: HelpData | null;
  error: string | null;
}
const initialState: Country = {
  countries: [],
  states: [],
  cities: [],
  CountryOfJurisdictionList: [],
  currencies: [],
  preferences: {},
  aiSettings: null,
  chatList: [],
  userTypes: [],
  MessageList: [],
  aiVoices: [],
  pubsub: null,
  loading: false,
  data: null,
  error: null,
};

const DataReducer = (state = initialState, action: HelpActionTypes | any) => {
  switch (action.type) {
    case SET_COUNTRY:
      return {
        ...state,
        countries: action.countries,
      };
    case SET_CURRENCY:
      return {
        ...state,
        currencies: action.currencies,
      };
    case SET_STATE:
      return {
        ...state,
        states: action.states,
      };
    case SET_CITY:
      return {
        ...state,
        cities: action.cities,
      };
    case SET_PREFERENCES:
    case GET_PREFERENCES_SUCCESS:
      return {
        ...state,
        preferences: action.preferences,
      };
    case SET_AI_SETTINGS:
    case GET_AI_SETTINGS_SUCCESS:
      return {
        ...state,
        aiSettings: action.aiSettings,
      };
    case SET_JURISDICTION_COUNTRY:
      return {
        ...state,
        CountryOfJurisdictionList: action.CountryOfJurisdictionList,
      };
    case SET_CHAT_LIST:
      return {
        ...state,
        chatList: action.chat_list,
      };
    case SET_MESSAGE_LIST:
      return {
        ...state,
        MessageList: action.message_list,
      };
    case SET_AI_VOICES:
      return {
        ...state,
        aiVoices: action.voices,
      };
    case GET_USER_MANUAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_USER_MANUAL_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case GET_USER_MANUAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case STORE_PUBSUB_CREDENTIALS:
      return {
        ...state,
        pubsub: action.payload,
      };
    case 'UPDATE_CHAT_LAST_MESSAGE': {
      const { chatID, lastmessageat, lastMessage, currentUserID, selectedChatId } = action.payload;

      let updatedChat: any = null;
      const restChats: any[] = [];

      state.chatList.forEach((chat: any) => {
        if (chat.ChatID === chatID) {
          const isChatCreatorSender = chat.SenderID === currentUserID;
          const isChatCreatorReceiver = chat.RecieverID === currentUserID;
          const isMessageFromOtherUser = lastMessage.SenderID !== currentUserID;
          const isChatOpen = chatID === selectedChatId;

          updatedChat = {
            ...chat,
            LastMessageAt: lastmessageat,
            LastMessage: lastMessage,
            UnreadCountSender:
              isChatCreatorSender && isMessageFromOtherUser && !isChatOpen
                ? (chat.UnreadCountSender || 0) + 1
                : chat.UnreadCountSender,
            UnreadCountReciever:
              isChatCreatorReceiver && isMessageFromOtherUser && !isChatOpen
                ? (chat.UnreadCountReciever || 0) + 1
                : chat.UnreadCountReciever,
          };
        } else {
          restChats.push(chat);
        }
      });

      return {
        ...state,
        chatList: updatedChat ? [updatedChat, ...restChats] : state.chatList,
      };
    };
    default:
      return state;
  }
};

export default DataReducer;
